import { render, staticRenderFns } from "./releseForm.vue?vue&type=template&id=a39001c6&scoped=true"
import script from "./releseForm.vue?vue&type=script&lang=js"
export * from "./releseForm.vue?vue&type=script&lang=js"
import style0 from "./releseForm.vue?vue&type=style&index=0&id=a39001c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39001c6",
  null
  
)

export default component.exports